import { HttpClientPort } from '../../../../core/domain/ports/HttpClientPort';
import {
  AnimaliaListResponseApiResponse,
  AnimaliaListingMapper,
} from '../../application/mappers/AnimaliaListingMapper';
import { AnimaliaListingResult } from '../../domain/entities/AnimaliaListingResult';
import {
  ANIMALIA_LIST_FILTER_KEYS,
  AnimaliaListFilters,
  AnimaliaListRepositoryPort,
} from '../../domain/ports/AnimaliaListRepositoryPort';

interface AnimaliaListRequestBody {
  filters?: AnimaliaListFilters;
  executedIds: string[];
}

export class AnimaliaListApiRepositoryAdapter implements AnimaliaListRepositoryPort {
  constructor(private readonly httpClient: HttpClientPort) {}

  async fetchList(
    filters: AnimaliaListFilters | undefined,
    executedIds: ReadonlyArray<string>,
  ): Promise<AnimaliaListingResult> {
    const normalizedFilters = this.normalizeFilters(filters);
    const response = await this.httpClient.post<AnimaliaListRequestBody, AnimaliaListResponseApiResponse>(
      '/api/v1/list',
      {
        ...(normalizedFilters ? { filters: normalizedFilters } : {}),
        executedIds: [...executedIds],
      },
    );

    return AnimaliaListingMapper.listingResultFromApiResponse(response);
  }

  private normalizeFilters(filters: AnimaliaListFilters | undefined): AnimaliaListFilters | undefined {
    if (!filters) {
      return undefined;
    }

    const normalizedFilters = ANIMALIA_LIST_FILTER_KEYS.reduce<AnimaliaListFilters>((accumulator, filterKey) => {
      const value = filters[filterKey];

      if (typeof value === 'string' && value.trim() !== '') {
        accumulator[filterKey] = value;
      }

      return accumulator;
    }, {});

    return Object.keys(normalizedFilters).length > 0 ? normalizedFilters : undefined;
  }
}
